import { resolveAbsoluteMediaUrl } from './api';
import { clinicLogo } from '../context/ClinicBrandingContext';
import { openIntakeRecordPreview } from './intakeDocument';

async function fetchMediaAsDataUrl(absoluteUrl) {
  if (!absoluteUrl) return '';
  try {
    const res = await fetch(absoluteUrl, { credentials: 'include', mode: 'cors' });
    if (!res.ok) return absoluteUrl;
    const blob = await res.blob();
    return await new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = () => resolve(String(reader.result || absoluteUrl));
      reader.onerror = () => resolve(absoluteUrl);
      reader.readAsDataURL(blob);
    });
  } catch {
    return absoluteUrl;
  }
}

/**
 * Imprime la historia clínica completa: resuelve logo a data URL y abre vista previa imprimible.
 * @param {object} params
 * @param {object} params.intake formulario intake_adult (estado actual)
 * @param {object} [params.consent] consentimiento
 * @param {object} [params.clinicInfo] branding (nombre y logo de la clínica)
 * @param {boolean} [params.autoPrint]
 */
export async function printIntakeRecord({ intake, consent, clinicInfo, autoPrint = false } = {}) {
  const clinicName = String(clinicInfo?.name || '').trim() || 'PodoclinicAM';
  const logoAbsolute = resolveAbsoluteMediaUrl(clinicLogo(clinicInfo));
  const logoDataUrl = logoAbsolute ? await fetchMediaAsDataUrl(logoAbsolute) : '';

  const payload = {
    clinicName,
    logoUrl: logoAbsolute,
    logoDataUrl: logoDataUrl || logoAbsolute,
    intake: intake || {},
    consent: consent || {},
  };

  return openIntakeRecordPreview(payload, { autoPrint });
}
